import '@angular/compiler';
import { PortalInstituteUserInfoComponent } from './portal.institute.user.info/portal.institute.user.info.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalSamlProvidersComponent } from './portal.saml.providers/portal.saml.providers.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PortalNoticeUserListComponent } from './portal.notice.user.list/portal.notice.user.list.component';
import { PortalAdminIssuesListComponent } from './portal.admin.issues.list/portal.admin.issues.list.component';
import { PageAdminPortsComponent } from './page.admin.ports/page.admin.ports.component';
import { ComponentHeaderComponent } from './component.header/component.header.component';
import { ComponentAlertComponent } from './component.alert/component.alert.component';
import { PortalInstituteAdminIssueComponent } from './portal.institute.admin.issue/portal.institute.admin.issue.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PageNoticeComponent } from './page.notice/page.notice.component';
import { ComponentNavComponent } from './component.nav/component.nav.component';
import { ComponentFooterComponent } from './component.footer/component.footer.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PortalKreonetAvailabilityDetailComponent } from './portal.kreonet.availability.detail/portal.kreonet.availability.detail.component';
import { PortalInstituteAdminDocumentComponent } from './portal.institute.admin.document/portal.institute.admin.document.component';
import { PortalNoticeUserDetailComponent } from './portal.notice.user.detail/portal.notice.user.detail.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { LayoutUserComponent } from './layout.user/layout.user.component';
import { PortalKreonetAvailabilityComponent } from './portal.kreonet.availability/portal.kreonet.availability.component';
import { PortalInstituteAdminIssueNoticeComponent } from './portal.institute.admin.issue.notice/portal.institute.admin.issue.notice.component';
import { PageAdminSystemItemComponent } from './page.admin.system.item/page.admin.system.item.component';
import { PortalInstituteUserIssueEditComponent } from './portal.institute.user.issue.edit/portal.institute.user.issue.edit.component';
import { PortalInstituteAdminIssueDetailComponent } from './portal.institute.admin.issue.detail/portal.institute.admin.issue.detail.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { PageAdminInstituteComponent } from './page.admin.institute/page.admin.institute.component';
import { PortalInstituteUserDocumentComponent } from './portal.institute.user.document/portal.institute.user.document.component';
import { PortalSamlSelectComponent } from './portal.saml.select/portal.saml.select.component';
import { PortalSamlSpConfigComponent } from './portal.saml.sp.config/portal.saml.sp.config.component';
import { PortalInstituteUserListComponent } from './portal.institute.user.list/portal.institute.user.list.component';
import { PortalInstituteTrafficComponent } from './portal.institute.traffic/portal.institute.traffic.component';
import { PortalInstituteUserIssueDetailComponent } from './portal.institute.user.issue.detail/portal.institute.user.issue.detail.component';
import { PortalInstituteAdminDetailComponent } from './portal.institute.admin.detail/portal.institute.admin.detail.component';
import { PortalInstituteUserDetailComponent } from './portal.institute.user.detail/portal.institute.user.detail.component';
import { PortalKreonetWeathermapComponent } from './portal.kreonet.weathermap/portal.kreonet.weathermap.component';
import { PortalKreonetNoticeComponent } from './portal.kreonet.notice/portal.kreonet.notice.component';
import { PortalKreonetPortStatusComponent } from './portal.kreonet.port.status/portal.kreonet.port.status.component';
import { PortalInstituteUserIssueComponent } from './portal.institute.user.issue/portal.institute.user.issue.component';
import { PageAuthenticateComponent } from './page.authenticate/page.authenticate.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalInstituteAdminListComponent } from './portal.institute.admin.list/portal.institute.admin.list.component';
import { ComponentNavAdminComponent } from './component.nav.admin/component.nav.admin.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalAdminIssuesDetailComponent } from './portal.admin.issues.detail/portal.admin.issues.detail.component';
import { PortalNoticeAdminDetailComponent } from './portal.notice.admin.detail/portal.notice.admin.detail.component';
import { PortalNoticeAdminListComponent } from './portal.notice.admin.list/portal.notice.admin.list.component';
import { ComponentNavUserComponent } from './component.nav.user/component.nav.user.component';
import { PageAdminNoticeComponent } from './page.admin.notice/page.admin.notice.component';
import { ComponentLoadingComponent } from './component.loading/component.loading.component';
import { PageAdminUsersComponent } from './page.admin.users/page.admin.users.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { PortalInstituteAdminInfoComponent } from './portal.institute.admin.info/portal.institute.admin.info.component';
import { PageInstitutesComponent } from './page.institutes/page.institutes.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PageAdminIssuesComponent } from './page.admin.issues/page.admin.issues.component';
import { PortalInstitutePopupPortsComponent } from './portal.institute.popup.ports/portal.institute.popup.ports.component';
import { ComponentPaginationComponent } from './component.pagination/component.pagination.component';
import { PortalSamlMgmtIdpComponent } from './portal.saml.mgmt.idp/portal.saml.mgmt.idp.component';

// const INDEX_PAGE = "main";
const INDEX_PAGE = "/authenticate"

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutUserComponent,
        "children": [
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "notice/:category/:id?",
                component: PageNoticeComponent,
                "app_id": "page.notice"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "institutes/:id?/:mode?/:item?",
                component: PageInstitutesComponent,
                "app_id": "page.institutes"
            }
        ]
    },
    {
        component: LayoutAdminComponent,
        "children": [
            {
                "path": "admin/ports",
                component: PageAdminPortsComponent,
                "app_id": "page.admin.ports"
            },
            {
                "path": "admin/system/:item?",
                component: PageAdminSystemItemComponent,
                "app_id": "page.admin.system.item"
            },
            {
                "path": "admin/institutes/:id?/:mode?/:item?",
                component: PageAdminInstituteComponent,
                "app_id": "page.admin.institute"
            },
            {
                "path": "admin/notices/:category/:id?",
                component: PageAdminNoticeComponent,
                "app_id": "page.admin.notice"
            },
            {
                "path": "admin/users",
                component: PageAdminUsersComponent,
                "app_id": "page.admin.users"
            },
            {
                "path": "admin/issues/:item?",
                component: PageAdminIssuesComponent,
                "app_id": "page.admin.issues"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "authenticate",
                component: PageAuthenticateComponent,
                "app_id": "page.authenticate"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }